<svg
	fill="currentColor"
	width="30px"
	viewBox="0 0 24 24"
	id="diagram-bar-uptrend"
	data-name="Flat Line"
	xmlns="http://www.w3.org/2000/svg"
	class="icon flat-line"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<path
			id="primary"
			d="M7,15v2m4-4v4m4-6v6m4-8v8"
			style="fill: none; stroke: currentColor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
		/>

		<path
			id="primary-2"
			data-name="primary"
			d="M3,3V20a1,1,0,0,0,1,1H21"
			style="fill: none; stroke: currentColor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
		/>
	</g>
</svg>
